import React from "react";

import { StyledInputTime } from "./style";

interface InputTimeProps {
  time: string;
  setTime: React.Dispatch<string>;
}

export const InputTime = ({time, setTime}: InputTimeProps) => {
  return (
    <StyledInputTime type="time" onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
      setTime(e.target.value)} value={time} />
  );
}